/** 
 * @type {import("./defs").StoreAdministrator} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreAdministrator} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreAdministrator.js